import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {openAccount as openAccountAction} from 'actions'
import {isTestnet} from 'constants'
import useUserLoginStatus from './useUserLoginStatus'

export default function useOpenAccountDataProvider () {
  const dispatch = useDispatch()
  const isLogin = useUserLoginStatus()
  const setData = useCallback(async () => {
    let isOpenAccount
    try {
      const res = await ApiSdk.futures.checkOpenAccountInfo()

      // TODO
      if (typeof res === 'boolean') {
        isOpenAccount = res
      } else {
        const {data = null, success = false} = res
        isOpenAccount = success && data
      }
      if (__DEV__) isOpenAccount = __DEV__
    } catch {
      isOpenAccount = __DEV__
    }
    dispatch(openAccountAction({isOpenAccount}))
  }, [dispatch])

  useEffect(() => {
    if (isTestnet) {
      dispatch(openAccountAction({isOpenAccount: true}))
    } else {
      isLogin && setData()
    }
  }, [dispatch, isLogin, setData])
}
